import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LoadingIconButton from 'y4/components/common/LoadingIconButton';
import React from 'react';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import { Col, Dropdown, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import SoftBadge from 'components/common/SoftBadge';

const AdvanceGridHeader = ({
  globalFilter,
  setGlobalFilter,
  selectedRowIds,
  buttonExecuter,
  buttons,
  badges
}) => {
  const show =
    !!setGlobalFilter ||
    (buttons && buttons.length > 0) ||
    (badges && badges.length > 0);
  if (!show) return null;

  const buttonClick = e => {
    if (buttonExecuter) return buttonExecuter(e, selectedRowIds);
  };

  return (
    <div className="d-lg-flex justify-content-between mb-3">
      <Row className="flex-between-center gy-2">
        {setGlobalFilter && (
          <Col xs="auto">
            <AdvanceTableSearchBox
              globalFilter={globalFilter}
              setGlobalFilter={setGlobalFilter}
            />
          </Col>
        )}
        {badges ? (
          <Col>
            <Flex wrap="wrap" className="gap-2">
              {badges.map((b, index) => (
                <SoftBadge
                  key={index}
                  pill
                  bg={b.type}
                  className="fs--1 fw-light"
                >
                  {b.icon ? (
                    <FontAwesomeIcon
                      icon={b.icon}
                      className="me-1"
                      transform="shrink-4"
                    />
                  ) : null}
                  {b.content}
                </SoftBadge>
              ))}
            </Flex>
          </Col>
        ) : null}
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-end">
        {buttons &&
          buttons
            .filter(item => {
              return item.type == 'embed';
            })
            .map((button, index) => {
              if (button.divider) {
                return (
                  <div
                    key={index}
                    className="bg-300 ms-2 d-none d-lg-block"
                    style={{ width: '1px', height: '29px' }}
                  ></div>
                );
              } else if (button.buttons) {
                return (
                  <Dropdown
                    key={index}
                    align="end"
                    className="btn-reveal-trigger d-inline-block ms-2"
                  >
                    <Dropdown.Toggle variant="falcon-default" size="sm">
                      <FontAwesomeIcon icon={button.icon} className="fs--2" />
                      {button.text && (
                        <span className="d-inline-block ms-1">
                          {button.text}
                        </span>
                      )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="border py-0">
                      <div className="py-2">
                        {button.buttons.map((sub_button, sub_index) => {
                          if (sub_button.divider) {
                            return <Dropdown.Divider key={sub_index} />;
                          } else {
                            return (
                              <Dropdown.Item
                                key={sub_index}
                                as="button"
                                type="button"
                                className={sub_button.className}
                                onClick={() => buttonClick(sub_button)}
                              >
                                {sub_button.text}
                              </Dropdown.Item>
                            );
                          }
                        })}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                );
              } else {
                return (
                  <LoadingIconButton
                    key={index}
                    variant="falcon-default"
                    size="sm"
                    icon={button.icon}
                    onClick={() => buttonClick(button)}
                    className={'ms-2 ' + button.className}
                    transform="shrink-3"
                    iconAlign="middle"
                  >
                    <span className="d-inline-block ms-1">{button.text}</span>
                  </LoadingIconButton>
                );
              }
            })}
      </div>
    </div>
  );
};

AdvanceGridHeader.propTypes = {
  selectedRowIds: PropTypes.object,
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func,
  buttonExecuter: PropTypes.func,
  buttons: PropTypes.array,
  badges: PropTypes.array
};

export default AdvanceGridHeader;
